import { Phone, Mail, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-sky-500 text-white">
              <Sparkles className="h-5 w-5" />
            </span>
            <span className="font-display text-xl font-extrabold text-white">
              Shine Express
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-sm">
            Professional car, home and tank cleaning. Shine like new — every time.
          </p>
        </div>

        <div>
          <h4 className="font-display text-white font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            <li>Car Cleaning</li>
            <li>House Cleaning</li>
            <li>Tank Cleaning</li>
            <li>Sofa Cleaning</li>
            <li>Solar Panel Cleaning</li>
            <li>All Cleanings</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-sky-400" />
              <a href="tel:+919673522737" className="hover:text-white">+91 96735 22737</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-sky-400" />
              <a href="mailto:shreevallabh2737@gmail.com" className="hover:text-white">shreevallabh2737@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Shine Express. All rights reserved.</p>
          <p className="mt-2 sm:mt-0">Shine like new.</p>
        </div>
      </div>
    </footer>
  );
}
